import React, { useState } from "react";
import cx from "classnames";
import { MdClose } from "react-icons/md";
// import PropTypes from 'prop-types'
import {
  PaymentsViewModalStyled,
  StatusInfoStyled,
  StatusNoticeModalStyled,
} from "./styled";
import {
  RENDER_ACKNOWLEDGED_STATUS,
  RENDER_BOOKING_STATUS,
  RENDER_BOOKING_STEP,
  RENDER_PAYMENT_METHOD,
  IS_ALL_PAYMENTS_ACKNOWLEDGED,
} from "utils/functions/musicHall";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import moment from "moment-timezone";
import { IMG_PATH } from "utils/constants/imgPath";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Buttons, Displays, Forms, Icons, Modals } from "components";
import { BtnComfirmSlipTranfersWidget } from "widgets";
// import ตรงไม่ผ่าน Cards index เพราะ StatusInfo เองก็อยู่ใน Cards (กัน circular import)
import RoomInfo from "../RoomInfo";
import CustomerInfo from "../CustomerInfo";

// ฟอร์มเปลี่ยนสถานะใช้ได้เฉพาะ 2, 3 (API adminAdvanchBooking รับแค่นี้)
// สถานะอื่นกด Submit แล้ว fail ทุกครั้ง เลยบอกแอดมินแทนว่าต้องไปทำอะไรต่อ
const STATUS_FORM_EDITABLE = ["2", "3"];
const STATUS_NOTICE = {
  1: "รอลูกค้าส่งรายละเอียดการจอง ยังไม่ต้องดำเนินการ",
  4: "รอตรวจสลิป กด “3.1 go to check” หรือไปที่แท็บ Transfer Slip เมื่อยืนยันการโอนแล้ว กรอกยอดชำระเงินที่ “3.2 Edit/Action” ในส่วน Payment ด้านล่าง",
  5: "จองสำเร็จแล้ว จัดการการชำระเงินและสถานะงานได้ที่ส่วน Payment ด้านล่าง",
  6: "รอลูกค้าแก้ไขข้อมูลแล้วส่งกลับมา ยังไม่ต้องดำเนินการ",
  7: "ลูกค้ายกเลิกการจองแล้ว",
};

const StatusInfo = ({
  theme_standard,
  _id,
  alternative_booking_dates,
  booking_admin_note,
  admin_customer_message,
  booking_date,
  booking_date_history,
  booking_source,
  booker_first_name,
  booker_last_name,
  booker_phone,
  booker_email,
  event_start_time,
  event_end_time,
  setup_cleanup_start_time,
  setup_cleanup_end_time,
  room_name_th,
  room_type,
  payments,
  pricing,
  requested_booking,
  status,
  step,
  onSuccess,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleCloseModal = () => {
    _setRenderModal(false);
  };
  const _handleClickModal = () => {
    if (!STATUS_FORM_EDITABLE.includes(status)) {
      _setRenderModal(
        <StatusNoticeModal
          message={STATUS_NOTICE[status] || "สถานะนี้ไม่สามารถแก้ไขได้"}
          onClose={_handleCloseModal}
        />,
      );
      return;
    }
    let params = {
      status: status,
    };
    if (pricing?.advance_booking_amount) {
      params.advance_booking_amount = pricing?.advance_booking_amount;
    }
    if (booking_admin_note) {
      params.booking_admin_note = booking_admin_note;
    }
    // API เขียนทับเป็นค่าว่างถ้าไม่ส่งมา ต้องใส่ค่าเดิมไว้ ไม่งั้นแก้สถานะรอบสองข้อความเดิมจะหาย
    if (admin_customer_message) {
      params.admin_customer_message = admin_customer_message;
    }
    _setRenderModal(
      <Forms.MusicHallStatusForm
        initialValues={params}
        status={status}
        bookerName={[booker_first_name, booker_last_name]
          .filter(Boolean)
          .join(" ")}
        onBack={_handleCloseModal}
        onSubmit={_handleSubmit}
      />,
    );
  };
  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      ...values,
    };
    let res = await portalService.PATCH_ROOM_BOOKING_ADVANCH_BOOKING(
      _id,
      params,
    );
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      _handleCloseModal();
      toast.success("Update status successfully");
      onSuccess && onSuccess();
    } else {
      _setIsBgLoading(false);
      toast.error(res?.data?.error?.message || "Update status failed");
    }
  };

  // เปลี่ยนวันจัดงานได้จนกว่าจะจ่ายครบ (สถานะ 5 = จ่ายครบแล้ว ล็อควัน)
  const isCanChangeEventDate =
    room_type === "1" &&
    (status === "2" || status === "3" || status === "4") &&
    alternative_booking_dates &&
    alternative_booking_dates.length > 0;

  const _handleClickEventDate = () => {
    _setRenderModal(
      <Forms.MusicHallEventDateForm
        booking_date={booking_date}
        requested_booking={requested_booking}
        alternative_booking_dates={alternative_booking_dates}
        onBack={_handleCloseModal}
        onSubmit={_handleEventDateSubmit}
      />,
    );
  };
  const _handleEventDateSubmit = async (values) => {
    _setIsBgLoading(true);
    let res = await portalService.PATCH_ROOM_BOOKING_EVENT_DATE(_id, {
      ...values,
    });
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      _handleCloseModal();
      toast.success("Update event date successfully");
      onSuccess && onSuccess();
    } else {
      _setIsBgLoading(false);
      toast.error(res?.data?.error?.message || "Update event date failed");
    }
  };

  const _handleClickViewPayments = () => {
    _setRenderModal(
      <PaymentsViewModal
        bookingId={_id}
        payments={payments}
        roomInfo={{
          booker_first_name,
          booking_date,
          booking_source,
          event_start_time,
          event_end_time,
          setup_cleanup_start_time,
          setup_cleanup_end_time,
          room_type,
          room_name_th,
        }}
        customerInfo={{
          booker_first_name,
          booker_last_name,
          booker_email,
          booker_phone,
        }}
        advanceBookingAmount={pricing?.advance_booking_amount}
        onClose={_handleCloseModal}
        onApproveSuccess={() => {
          _handleCloseModal();
          onSuccess && onSuccess();
        }}
      />,
    );
  };

  const renderStatus = RENDER_BOOKING_STATUS(status);
  // เลข step บนปุ่ม Edit/Action ให้ตรงกับวงกลม step ด้านบน พนักงานจะได้รู้ว่าต้องกดปุ่มไหน
  const renderStep = RENDER_BOOKING_STEP(step);
  // ปุ่มสีม่วง + เลข = แอดมินมีงานต้องกดปุ่มนี้ / สีขาวไม่มีเลข = ไม่มีอะไรต้องทำที่ปุ่มนี้
  // ปุ่ม Edit/Action ของ Status มีงานแค่ status 2 (ยืนยันรายละเอียด = step 1)
  // งานช่วงอื่นอยู่ที่ "3.1 go to check" และปุ่ม Edit/Action ส่วน Payment (3.2, 4)
  const isStatusAction = status === "2";
  // step 3 ใช้สีเดียวกับวงกลม step เพราะสี status "4" ซ้ำกับ step 2 (เหมือนตารางหน้า list)
  const pillColor = step === 3 ? renderStep : renderStatus;
  // ยืนยันสลิปครบทุกใบแล้ว เหลือกรอกยอดที่ 3.2 (Edit/Action ส่วน Payment) ซึ่ง API จะเปลี่ยน 4 -> 5 ให้เอง
  const isAllSlipsAcknowledged =
    status === "4" && IS_ALL_PAYMENTS_ACKNOWLEDGED(payments);
  const adminTodoText = isAllSlipsAcknowledged
    ? "กรุณากรอกยอดชำระเงิน เพื่อปรับสถานะเป็น Booking Success อัตโนมัติที่ 3.2"
    : renderStatus.adminTodoEn;
  return (
    <>
      <Displays.BGLoading visible={_isBgLoading} />
      <StatusInfoStyled
        className={customClass}
        statusBgColor={pillColor.bgColor}
        statusTxtColor={pillColor.txtColor}
        adminTodoColor={renderStatus.adminTodoColor}
        stepBgColor={renderStep.bgColor}
        stepTxtColor={renderStep.txtColor}
      >
        <div
          className={cx("statusinfo_row_status status_main_row", {
            is_action: isStatusAction,
          })}
        >
          <div className="statusinfo_status">Status</div>
          <div className="statusinfo_status2 ">{renderStatus.labelEn}</div>
          {status !== "8" && (
            <Buttons.BgIconPrefix
              theme_edit_action
              label="Edit/Action"
              icon={
                <>
                  {isStatusAction && step ? (
                    <span className="btn_step_no">{step}</span>
                  ) : null}
                  <Icons.Edit />
                </>
              }
              status={status}
              onClick={_handleClickModal}
            />
          )}
        </div>
        <div className="statusinfo_row admin_todo_row">
          <div className="statusinfo_text1">
            <span className="statusinfo_highlight">Admin To do</span>
          </div>
          <div className="statusinfo_text3 statusinfo_highlight">
            {adminTodoText}
          </div>
          {status === "4" && payments && payments.length > 0 && (
            <div className="statusinfo_link" onClick={_handleClickViewPayments}>
              3.1 go to check
            </div>
          )}
        </div>
        <div className="statusinfo_row">
          <div className="statusinfo_text1">Show on customer side</div>
          <div className="statusinfo_text4 ">
            {step? `${step}.`: ""} {renderStatus.customerLabelEn}
          </div>
        </div>
        <div className="statusinfo_row">
          <div className="statusinfo_text1">Message to customer</div>
          <div className="statusinfo_text2 ">{admin_customer_message}</div>
        </div>
        <div className="statusinfo_row">
          <div className="statusinfo_text1">Admin Note</div>
          <div className="statusinfo_text2 ">{booking_admin_note}</div>
        </div>
        <div className="statusinfo_row_status">
          <div className="statusinfo_status">Event Date</div>
          <div className="statusinfo_status2 ">
            {moment(booking_date).format("DD/MM/YYYY")}
          </div>
          {isCanChangeEventDate && (
            <Buttons.BgIconPrefix
              theme_edit_action
              label="เปลี่ยนวันจัดงาน"
              icon={<Icons.Edit />}
              onClick={_handleClickEventDate}
            />
          )}
        </div>
        {booking_date_history && booking_date_history.length > 0 && (
          <div className="statusinfo_row">
            <div className="statusinfo_text1">ประวัติการเปลี่ยนวัน</div>
            <div className="statusinfo_text2 ">
              {booking_date_history.map((e, i) => (
                <div key={i}>
                  {moment(e.from).format("DD/MM/YYYY")} →{" "}
                  {moment(e.to).format("DD/MM/YYYY")}
                  {e.reason ? ` (${e.reason})` : ""}
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="statusinfo_row_reserve">
          <div className="statusinfo_reserve_text1">ยอดแจ้งจองห้องล่วงหน้า</div>
          <div className="statusinfo_reserve_text2">
            {RenderCommaMoney(pricing.advance_booking_amount)}
          </div>
          <div className="statusinfo_reserve_date">
            <div className="statusinfo_date">
              {pricing.advance_booking_date
                ? moment(pricing.advance_booking_date).format("DD/MM/YYYY")
                : ""}
            </div>
            <div className="statusinfo_date2">Added by admin</div>
          </div>
        </div>
      </StatusInfoStyled>
      <Modals.BodyEmpty
        isShowModal={!!_renderModal}
        onCloseModal={_handleCloseModal}
      >
        {_renderModal}
      </Modals.BodyEmpty>
    </>
  );
};

StatusInfo.propTypes = {};

const StatusNoticeModal = ({ message, onClose }) => (
  <StatusNoticeModalStyled>
    <div className="snm_title">ไม่มีการดำเนินการในสถานะนี้</div>
    <div className="snm_message">{message}</div>
    <div className="snm_action">
      <Buttons.BgStandard theme_purple label="ตกลง" onClick={onClose} />
    </div>
  </StatusNoticeModalStyled>
);

const formatBkkDateTime = (date) =>
  date ? moment(date).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm") : "-";

const PaymentsViewModal = ({
  bookingId,
  payments,
  roomInfo,
  customerInfo,
  advanceBookingAmount,
  onClose,
  onApproveSuccess,
}) => {
  const list = Array.isArray(payments) ? payments : [];
  return (
    <PaymentsViewModalStyled>
      <div className="pvm_header">
        <div className="pvm_title">รายละเอียดการชำระเงิน</div>
        <div className="pvm_close" onClick={onClose}>
          <MdClose size={20} />
          ปิด
        </div>
      </div>

      {/* ข้อมูลระดับ booking แสดงครั้งเดียว ไม่ซ้ำทุกสลิป */}
      <div className="pvm_booking">
        <div className="pvm_detail_row">
          <div className="pvm_detail_col">
            <div className="pvm_section_title">Booking Detail</div>
            <RoomInfo {...roomInfo} />
          </div>
          <div className="pvm_detail_col">
            <div className="pvm_section_title">Customer Detail</div>
            <CustomerInfo {...customerInfo} />
          </div>
        </div>
        <div className="pvm_amount_row">
          <div className="pvm_amount_label">ยอดเรียกเก็บ</div>
          <div className="pvm_amount_value">
            {advanceBookingAmount
              ? `${RenderCommaMoney(advanceBookingAmount)} บาท`
              : "-"}
          </div>
        </div>
      </div>

      {list.length === 0 ? (
        <div className="pvm_empty">ไม่มีข้อมูลการชำระเงิน</div>
      ) : (
        <div className="pvm_list">
          {list.map((p, i) => {
            const methodInfo = RENDER_PAYMENT_METHOD(p.payment_method);
            const ackInfo = RENDER_ACKNOWLEDGED_STATUS(p.acknowledged_status);
            // ข้อมูลธนาคารมาจาก slip2go ฝั่ง "ผู้รับเงิน" ใช้เช็คว่าโอนเข้าบัญชียามาฮ่าจริง
            // สลิปที่แอดมินบันทึกเองไม่มีข้อมูลพวกนี้ จึงแสดงเฉพาะแถวที่มีค่า
            const transferFields = [
              { label: "วันเวลาที่โอน", value: formatBkkDateTime(p.paid_at) },
              { label: "ช่องทาง", value: methodInfo.labelTh || "-" },
              { label: "ธนาคารผู้รับ", value: p.bank_service, optional: true },
              { label: "ชื่อบัญชีผู้รับ", value: p.bank_account_name, optional: true },
              { label: "เลขบัญชีผู้รับ", value: p.bank_account_number, optional: true },
              { label: "เลขอ้างอิงธุรกรรม", value: p.trans_ref, optional: true },
              {
                label: "บันทึกโดย",
                value: p.create_by_type === "2" ? "แอดมิน" : "ลูกค้า",
              },
              { label: "วันเวลาที่บันทึก", value: formatBkkDateTime(p.created_at) },
              {
                label: "รับทราบเมื่อ",
                value: p.acknowledged_at && formatBkkDateTime(p.acknowledged_at),
                optional: true,
              },
              { label: "หมายเหตุ", value: p.acknowledge_note, optional: true },
            ].filter((f) => !f.optional || f.value);
            return (
              <div key={p._id || i} className="pvm_card">
                <div className="pvm_card_header">
                  <div className="pvm_index">ชำระเงินวันที่</div>
                  <div className="pvm_date">
                    {p.paid_at
                      ? moment(p.paid_at)
                          .tz("Asia/Bangkok")
                          .format("DD/MM/YYYY")
                      : "-"}
                  </div>
                  <div
                    className="pvm_method"
                    style={{ color: methodInfo.txtColor }}
                  >
                    {methodInfo.labelTh}
                  </div>
                </div>

                <div className="pvm_transfer">
                  <div className="pvm_section_title">รายละเอียดการโอนเงิน</div>
                  <div className="pvm_amount_row">
                    <div className="pvm_amount_label">ยอดการโอนเงิน</div>
                    <div className="pvm_amount_value">
                      {RenderCommaMoney(p.transfer_amount)} บาท
                    </div>
                  </div>
                  <div className="pvm_transfer_grid">
                    {transferFields.map((f) => (
                      <div key={f.label} className="pvm_field">
                        <div className="pvm_label">{f.label}:</div>
                        <div className="pvm_value">{f.value}</div>
                      </div>
                    ))}
                    <div className="pvm_field">
                      <div className="pvm_label">ตรวจสอบสลิปโอนเงิน:</div>
                      {p.slip_upload ? (
                        <a
                          className="pvm_link"
                          href={IMG_PATH + p.slip_upload}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Link
                        </a>
                      ) : (
                        <div className="pvm_value">-</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="pvm_card_footer">
                  <div className="pvm_status_wrap">
                    <div className="pvm_label">Status:</div>
                    <Displays.StatusLabel
                      bg={ackInfo.bgColor}
                      txtColor={ackInfo.txtColor}
                      label={ackInfo.labelTh}
                    />
                  </div>
                  {p.acknowledged_status === "1" && (
                    <BtnComfirmSlipTranfersWidget
                      _id={bookingId}
                      payment_id={p._id}
                      label="ยืนยันการโอน"
                      onSuccess={onApproveSuccess}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </PaymentsViewModalStyled>
  );
};

export default StatusInfo;
